<template>
    <div>

        <config-main-title>
            Status de Laudo
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Status
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Status identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Status'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span v-if="dado && dado.id_status_laudo" class="badge badge-secondary">
                            #{{ dado.id_status_laudo }}
                        </span>
                        <small class="text-muted ml-3">{{ dado.st_acao }}</small>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else-if="dado.st_color">
                            <i class="fa fa-check text-success mr-3" aria-hidden="true" v-if="dado.fl_pronto" title="Indicação de laudo pronto."></i>
                            <i class="fa fa-ban text-danger mr-3" aria-hidden="true" v-if="dado.fl_nao_coletar" title="Indicação de não coleta."></i>
                            <span class="badge" :class="'badge-' + dado.st_color">
                                {{ dado.in_regra_ordem ? dado.in_regra_ordem : '&nbsp;' }}
                            </span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_status_laudo ? '' : 'Novo' }}
                            Status de Laudo
                            <span v-if="item && item.id_status_laudo" class="badge badge-secondary ml-2">
                                #{{ item.id_status_laudo }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Nome do status..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_status_laudo" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Ação"
                                    placeholder="Verbo da ação que leva ao status..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_acao" />
                            </div>
                        
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Cor"
                                    type="select"
                                    :validate="validate"
                                    :optionsList="[
                                        { id: 'primary', search: 'Azul' },
                                        { id: 'success', search: 'Verde' },
                                        { id: 'danger', search: 'Vermelho' },
                                        { id: 'dark', search: 'Preto' },
                                        { id: 'secondary', search: 'Cinza' },
                                        { id: 'warning', search: 'Amarelo' },
                                        { id: 'info', search: 'Ciano' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_color">
                                    <template v-slot:buttonposb v-if="item.st_color">
                                        <div class="input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa-solid fa-square" :class="'text-' + item.st_color"></i>
                                            </div>
                                        </div>
                                    </template>
                            </az-input>
                            </div>
                        </div>

                        <div class="mt-3">

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Laudo Pronto"
                                        :validate="validate"
                                        :edicao="!item.fl_nao_coletar && !item.fl_revisao"
                                        v-model="item.fl_pronto" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Laudo para Revisão"
                                        :validate="validate"
                                        :edicao="!item.fl_pronto && !item.fl_nao_coletar"
                                        v-model="item.fl_revisao" />
                                </div>
                            </div>
                            
                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Não Coletar"
                                        :validate="validate"
                                        :edicao="!item.fl_pronto && !item.fl_revisao"
                                        v-model="item.fl_nao_coletar" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Audio Gravado"
                                        :validate="validate"
                                        :edicao="!item.fl_pronto"
                                        v-model="item.fl_audio_gravado" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Definir responsável pela próxima etapa ao colocar nesse status"
                                        :validate="validate"
                                        :edicao="!item.fl_pronto"
                                        v-model="item.fl_info_resp" />
                                </div>
                            </div>

                        </div>

                        <div class="form-row" v-if="item.fl_info_resp && tags_usuarios && tags_usuarios.length">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="select"
                                    label="Classe do Responsável"
                                    placeholder="Todas..."
                                    :optionsList="tags_usuarios"
                                    optionsData="id"
                                    :validate="validate" 
                                    v-model="item.st_resp_classe" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="select"
                                    label="Ação Especial"
                                    placeholder="Nenhuma"
                                    :optionsList="[
                                        { id: 'C', search: 'Chamar Paciente' },
                                        { id: 'I', search: 'Iniciar Atendimento' },
                                        { id: 'F', search: 'Finalizar Atendimento' },
                                        { id: 'X', search: 'Cancelar Atendimento' },
                                        { id: 'E', search: 'Laudo em Andamento' },
                                        { id: 'N', search: 'Recoleta' },
                                        { id: 'D', search: 'Distribuir (Agenda Compartilhada)' },
                                    ]"
                                    optionsData="id"
                                    :validate="validate" 
                                    v-model="item.st_acao_especial" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="number"
                                    label="Número de Ordem"
                                    :validate="validate"
                                    v-model="item.in_regra_ordem" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Formulário de Coleta de Dados"
                                    placeholder="Nenhum..."
                                    type="select"
                                    service="modelos.index"
                                    optionsMode="aql"
                                    optionsName="modelos-index-pre-atend"
                                    :optionsParm="{ mode: 'selecao', pre: 1, ativos: 1, simples: 1 }"
                                    optionsData="id_modelo_prontuario"
                                    v-model="item.id_modelo_prontuario" /> 
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="statusLaudo" :id="item.id_status_laudo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_status_laudo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            tags_usuarios: [], 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        incluir () { 
            this.validate = false;

            let item = {
                id_status_laudo: null, 
                st_status_laudo: "", 
                st_acao: "", 
                st_color: "primary",
                fl_pronto: false, 
                in_regra_ordem: 9999,
                st_acao_especial: "", 
                fl_info_resp: false, 
                st_resp_classe: "", 
                fl_revisao: false, 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'status_laudos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            if ( !this.item.endereco ) { 
                this.item.endereco = { cidade: {} };
            }

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'status_laudos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
                callback: () => { 
                    this.$util.resync(this, 'status_laudos.index');
                }
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'status_laudos',
                dados: item,
                callback: () => { 
                    this.$util.resync(this, 'status_laudos.index');
                }
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Status de Laudo", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, { 
            service: 'usuarios',
            func: 'tags',
        })
        .then(res => { 
            this.tags_usuarios = res 
                ? res.map(item => { 
                    return {
                        id: item,
                        search: item,
                    }
                })
                : [];
        });

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>
